import React from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Founder } from "@/components/Founder";
import { BrandsCta } from "@/components/BrandsCta";
import { Footer } from "@/components/Footer";
import { useLenis } from "@/hooks/useLenis";

export default function Landing() {
  useLenis();
  return (
    <div className="App" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Founder />
      <BrandsCta />
      <Footer />
    </div>
  );
}
